import Image from 'next/image';

import styles from './Location.module.scss';

export interface Props {
  locationName: string;
}

const Location = ({ locationName }: Props) => (
  <div className={styles.location}>
    <div className={styles['location-icon']}>
      <Image alt="" unoptimized={true} src="/static/images/icons/Icon_Location.svg" layout="fill" />
    </div>
    <span className={styles['location-name']}>{locationName}</span>
  </div>
);

export default Location;
